import { RemoveItemParams } from "../types";
import { sortProducts } from "../utils/productUtils";

const removeItem = async (props: RemoveItemParams) => {
  const { sku, fetchedProducts, setFetchedProducts } = props;

  const newFetchedProducts = fetchedProducts.filter((product) => product.csvLineArray[0] !== sku);

  setFetchedProducts([...sortProducts(newFetchedProducts)]);
};

export default removeItem;
